jQuery(document).ready(function($) {
    function updateFreeBundleVisibility() {
        const selectedValues = new Set();

        $('.bcpo-front-button-option').each(function() {
            if ($(this).is(':checked')) {
                selectedValues.add($(this).val().replace('"', ''));
            }
        });

        $('input[name="properties[Free Bundle]"]').each(function() {
            const $option = $(this);
            const optionValue = $option.val().replace('"', '');
            if (selectedValues.has(optionValue)) {
                $option.closest('.bcpo-button-parent').hide();
            } else {
                $option.closest('.bcpo-button-parent').show();
            }
        });
    }

    $(document).on('change', '.bcpo-front-button-option', updateFreeBundleVisibility);

    // Initial call to set the correct visibility on page load
    updateFreeBundleVisibility();
});